import React from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import EditableField from "./EditableField";
import RepeatPreview from "./RepeatPreview";

const TaskDetailDrawer = ({
    task,
    onClose,
    onUpdateField,
    leadOptions,
    assignOptions,
    apiUrl,
    role,
    TaskHistory,
}) => {
    if (!task) return null;

    const readOnly = role === "staff" && task.assigned_by === "Admin";

    const fields = [
        { label: "Title", field: "title" },
        { label: "Due Date", field: "due_date" },
        { label: "Repetition", field: "repetition" },
        { label: "Priority", field: "priority" },
        { label: "Assign To", field: "assign_to" },
        { label: "Add to List", field: "list_id" },
        { label: "Notes", field: "notes", fullWidth: true },
        { label: "Attachment", field: "attachment", fullWidth: true },
    ];

    return (
        <>
            <motion.div
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ type: "tween", duration: 0.3 }}
                className="w-full md:w-auto p-2 bg-surface shadow rounded-xl border border-line flex-1 md:relative fixed inset-y-0 top-16 right-0 z-50 overflow-y-auto md:overflow-visible md:translate-x-0 md:top-0 md:z-0"
            >
                <div className="flex justify-between items-center mb-4 border-b border-line pb-2">
                    <h2 className="text-md font-semibold text-ink">Task Details</h2>
                    <button type="button" onClick={onClose}>
                        <X size={20} className="text-ink-secondary" />
                    </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                    {fields.map(({ label, field, fullWidth }) => (
                        <div
                            key={field}
                            className={fullWidth ? "col-span-1 md:col-span-2" : ""}
                        >
                            <p className="font-medium text-ink-muted text-xs mb-0.5">
                                {label}
                            </p>
                            <EditableField
                                value={task[field]}
                                field={field}
                                onChange={(val) => onUpdateField(task.id, field, val)}
                                leadOptions={leadOptions}
                                assignOptions={assignOptions}
                                assignedBy={task.assigned_by}
                                apiUrl={apiUrl}
                                readOnly={readOnly}
                            />
                        </div>
                    ))}
                </div>
                <RepeatPreview task={task} />
                {TaskHistory && (
                    <TaskHistory history={task?.historyTasks || []} />
                )}
            </motion.div>
            <div
                className="fixed inset-0 bg-black/30 z-40 md:hidden"
                onClick={onClose}
                aria-hidden
            />
        </>
    );
};

export default TaskDetailDrawer;
